/**
 * Notification types - matches Notification_Type enum in PHP
 */
export const NOTIFICATION_TYPES = {
	VIDEO_REQUEST: 'video_request',
	VIDEO_SESSION: 'video_session',
	STUDENT_ASSIGNED: 'student_assigned',
	STUDENT_QUESTION: 'student_question',

	REMINDER: 'reminder',
	REMIND_COACH_MESSAGE: 'remind_coach_message',
	MILESTONE_REACHED: 'milestone_reached',
	AWARD: 'award',
	WEEKLY_UPDATE: 'weekly_update',
	DAILY_REMINDER: 'daily_reminder'
};


/**
 * Notification config - maps notification types to their display styles
 */
export const NOTIFICATION_CONFIG = {
	[NOTIFICATION_TYPES.VIDEO_REQUEST]: {
		bg: 'bg-[#FAF5FF]',
		icon: 'fi fi-rr-video-camera text-[#9810FA]'
	},

	[NOTIFICATION_TYPES.VIDEO_SESSION]: {
		bg: 'bg-[#FAF5FF]',
		icon: 'fi fi-rr-video-camera text-[#9810FA]'
	},

	[NOTIFICATION_TYPES.STUDENT_ASSIGNED]: {
		bg: 'bg-[#EFF6FF]',
		icon: 'fi fi-rr-user-add text-[#155DFC]'
	},

	[NOTIFICATION_TYPES.STUDENT_QUESTION]: {
		bg: 'bg-warning-100',
		icon: 'fi fi-rr-comment-alt text-warning-500'
	},
	[NOTIFICATION_TYPES.REMIND_COACH_MESSAGE]:{
		'bg': 'bg-[#EFF6FF]',
		'icon': 'fi fi-rr-chat text-[#155DFC]'
	},

	[NOTIFICATION_TYPES.REMINDER]: {
		bg: 'bg-gray-25',
		icon: 'fi fi-rr-scale text-gray-500'
	},

	[NOTIFICATION_TYPES.MILESTONE_REACHED]: {
		bg: 'bg-[#FEFCE8]',
		icon: 'fi fi-rr-trophy text-[#D08700]'
	},

	[NOTIFICATION_TYPES.AWARD]: {
		bg: 'bg-success-50',
		icon: 'fi fi-rr-gift-2 text-success-500'
	},

	[NOTIFICATION_TYPES.WEEKLY_UPDATE]: {
		bg: 'bg-[#FAF1FF]',
		icon: 'fi fi-sr-chart-arrow-down-2 text-[#8B34D8]'
	},

	[NOTIFICATION_TYPES.DAILY_REMINDER]: {
		bg: 'bg-success-50',
		icon: 'fi fi-rr-salad text-success-500'
	}
};


/**
 * Notification store
 */
class NotificationStore {
	constructor() {
		this.notifications = []; // Will be loaded from CMS
		this.filter = 'all';
		this.userRole = 'end-user-client'; // Default role
	}

	/**
	 * Set user role
	 */
	setUserRole(role) {
		this.userRole = role || 'end-user-client';
	}

	/**
	 * Set notifications from CMS
	 */
	setNotifications(notifications) {
		this.notifications = notifications || [];
	}

	/**
	 * Set filter
	 */
	setFilter(filter) {
		this.filter = filter;
	}

	/**
	 * Get notifications by filter (all or unread)
	 */
	getFilteredNotifications(filterOverride) {
		const filter = filterOverride || this.filter || 'all';

		if (filter === 'unread') {
			return this.notifications.filter(n => !n.is_read);
		}
		return [...this.notifications];
	}

	/**
	 * Count notifications by filter
	 */
	getCount(filter = 'all') {
		if (filter === 'unread') {
			return this.notifications.filter(n => !n.is_read).length;
		}
		return this.notifications.length;
	}

	/**
	 * Mark notification as read
	 */
	markAsRead(id) {
		const notification = this.notifications.find(n => String(n.id) === String(id));
		if (notification) {
			notification.is_read = true;
		}
	}

	markAsUnread(id) {
		const notification = this.notifications.find(n => String(n.id) === String(id));
		if (notification) {
			notification.is_read = false;
		}
	}

	/**
	 * Mark all notifications as read
	 */
	markAllAsRead() {
		this.notifications.forEach(n => {
			n.is_read = true;
		});
	}

	/**
	 * Remove notification
	 */
	removeNotification(id) {
		this.notifications = this.notifications.filter(n => String(n.id) !== String(id));
	}
}

const notificationStore = new NotificationStore();
export { notificationStore };
